import { styled } from '@mui/material/styles';
import { DatagridWithStickyActions } from 'shared/react-admin/Datagrids/DatagridWithStickyActions/DatagridWithStickyActions';
import { ImageField } from 'shared/react-admin/Fields';
import { getColumnStyle } from 'utils';

export const DatagridStyled = styled(DatagridWithStickyActions)({
  '& .column-name': getColumnStyle(200),
  '& .column-filePath': getColumnStyle(90),
  '& .column-undefined': { width: '100%' },
  '& .column-createdAt': getColumnStyle(120),
  '& .column-updatedAt': getColumnStyle(120),
});

export const ImageFieldStyled = styled(ImageField)({
  '& .RaImageField-image': {
    maxWidth: 40,
    maxHeight: 40,
    minWidth: 40,
    minHeight: 40,
    objectFit: 'contain',
    margin: 0,
  },
});
